export enum RedirectParam {
  redirectTo = 'redirectTo',
  redirectToParams = 'redirectToParams',
  redirectOther = 'redirect_url',
}
